// C:\Users\91701\OneDrive\Desktop\jamia wbsite\JMA_Website\src\components\WordSpacedText.js
import styled from "styled-components";

const WordSpacedText = styled.span`
  word-spacing: 0.3rem;   /* reduce word space slightly */
  letter-spacing: 0.02em; /* optional: spacing between letters */
       /* ↓ decreased font size (adjust as needed) */
  font-family: 'CustomFont', sans-serif; /* use your custom font */
  text-xs lg:text-xl  
`;

export default WordSpacedText;
